import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from 'firebase/firestore';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';


const firebaseConfig = {
    apiKey: "AIzaSyDc6gmS9JxLD4B1h4Pvj1tlrODkt8jptfM",
    authDomain: "ehet-db.firebaseapp.com",
    projectId: "ehet-db",
    storageBucket: "ehet-db.appspot.com",
    messagingSenderId: "539229386057",
    appId: "1:539229386057:web:b4a33e8ca952266f6f5698",
    measurementId: "G-ESZZ3C1Q0S"
};


const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export const db = getFirestore(app);
export const auth = getAuth();
export const provider = new GoogleAuthProvider();
provider.setCustomParameters({ prompt: 'select_account' });
